import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {DefaultAppPageModule} from '../../../../components/common/defaut-application-page/default-app-page.module';
import {ContentModule} from '../../../../shared/directives/content.module';
import {ButtonModule} from '../../component/button/button.module';
import {LoadingModule} from '../../../../components/common/loading/loading.module';
import {ActionDefaultComponent} from './action-default.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        ContentModule,
        ButtonModule,
        LoadingModule,
    ],
    declarations: [ActionDefaultComponent],
    exports: [ActionDefaultComponent]
})
export class ActionDefaultModule {
}
